import Http from "./Http";

export class SubscriptionsService extends Http {
  /**
   * Create new subscription
   * @param {Object} body
   * @param {string} body.title
   * @param {number} body.imageId
   * @param {string} body.description
   * @param {number} body.priceType 1 - usd, 2 - matic
   * @param {string} body.monthlyPrice decimal MATIC or USD price
   * @param {string} body.semiAnnualPrice decimal MATIC or USD price
   * @param {string} body.annualPrice decimal MATIC or USD price
   */
  createSubscription(body) {
    return this.post("/subscriptions", body);
  }

  /**
   * Get creator's subscriptions
   * @param {string} username users unique key
   * @param {Object} params
   * @param {number} params.limit
   * @param {number} params.offset
   */
  getSubscription(username, params) {
    return this.get(`/users/${username}/subscriptions`, { params });
  }

  /**
   * Edit created subscription
   * @param {number} id
   * @param {Object} body
   * @param {string} body.title
   * @param {number} body.imageId
   * @param {string} body.description
   * @param {number} body.priceType 1 - usd, 2 - matic
   * @param {string} body.monthlyPrice decimal MATIC or USD price
   * @param {string} body.semiAnnualPrice decimal MATIC or USD price
   * @param {string} body.annualPrice decimal MATIC or USD price
   */
  editSubscription(id, body) {
    return this.put(`/subscriptions/${id}`, body);
  }

  /**
   * Get list of subscriptions
   * @param {Object} params
   * @param {number} params.limit
   * @param {number} params.offset
   * @param {number} params.startDate
   * @param {number} params.endDate
   * @param {number} params.orderBy Order fields: createdAt, nextPaymentAt, price
   * @param {number} params.orderType Order types: asc, desc
   * @param {number} params.priceType Supported values: 1 - usd, 2 - matic
   * @param {number} params.status 1 - active, 2 - canceled, 3 - expired, 4 - notAvailable, 5 - pending, 6 - incomplete
   * @param {number} params.isIncome false, true
   */
  getListPaymentSubscriptions(params) {
    return this.get("/payments/subscriptions", { params });
  }

  /**
   * Buy subscription
   * @param {number} id
   * @param {object} body
   * @param {number} body.durationType  1 - monthly, 2 - semiAnnual, 3 - annual
   * @param {string} body.paymentMethod
   * @param {string} body.transactionHash
   * @param {string?=} body.referral
   */
  purchaseSubscription(id, body) {
    return this.post(`/subscriptions/${id}/payments`, body);
  }

  /**
   * Get subscription details
   * @param {string} uniqueKey
   */
  getSubscriptionById(uniqueKey) {
    return this.get(`/subscriptions/${uniqueKey}`);
  }

  /**
   * Get subscription posts
   * @param {number} id
   * @param {number} params.limit
   * @param {number} params.offset
   */
  getSubscriptionPosts(id, params) {
    return this.get(`/subscriptions/${id}/posts`, { params });
  }

  /**
   * Cancel subscription
   * @param {number} id subscription id
   */
  cancelSubscription(id) {
    return this.delete(`/users/me/subscriptions/${id}`);
  }

  /**
   * Attach posts to existing subscription
   * @param {number} id subscription id
   * @param {Object} body
   * @param {boolean} body.isSelectAllPosts
   * @param {number[]} body.excludedPostIds
   * @param {number[]} body.includedPostIds
   */
  attachPost(id, body) {
    return this.put(`/subscriptions/${id}/posts`, body);
  }

  /**
   * Delete subscription by id
   * @param {number} id subscription id
   */
  deleteSubscription(id) {
    return this.delete(`/subscriptions/${id}`);
  }

  /**
   * Change position of subscription
   * @param {number} id
   * @param {Object} body
   * @param {number} body.position
   */
  updateOrder(id, body) {
    return this.patch(`/subscriptions/${id}/position`, body);
  }
}

export default new SubscriptionsService();
